import { Box, Grid } from "@material-ui/core";
import { useNotify, useRedirect } from "ra-core";


import LayoutContainer from "../components/LayoutContainer";
import LeftGridEdit from "../components/LeftGridEdit";
import RightGridEdit from "../components/RightGridEdit";
import TextInputRA from "../components/TextInputRA";
import GeneralSelect from "../components/GeneralSelect";
import StatusInput from "../components/StatusInput";
import OfferEditValidation from "../../../ValidationRules/OfferEditValidation";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import { Loading } from "react-admin";
import useCheckPermissionHook from "../../../hooks/useCheckPermissionHook";

const transform = (data) => {
  return {
    ...data,
    conditions: [
      {
        condition_id: data.conditions[0].condition_id,
        value: Number(data.conditions[0].value),
      },
    ],
    items: [
      {
        coupon_id: data.items[0].coupon_id,
        value: Number(data.items[0].value),
      },
    ],
  };
};

const OfferEdit = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const { loading, allow } = useCheckPermissionHook({
    code: "Page.Merchant.Management.Offer",
    write: true,
  });
  if (loading) return <Loading />;
  const onSuccess = () => {
    notify("Edit successfully"); // default message is 'ra.notification.updated'
    redirect("list", props.basePath);
  };
  const onFailure = (error) => {
    console.error(error);
    if (error.code === 123) {
      notify(
        "Could not save changes: concurrent edition in progress",
        "warning"
      );
    } else {
      notify("ra.notification.http_error", "warning");
    }
    redirect("list", props.basePath);
  };
  return (
    <LayoutContainer>
      <Grid container style={{ height: "100%" }}>
        <LeftGridEdit
          onSuccess={onSuccess}
          onFailure={onFailure}
          {...props}
          validate={OfferEditValidation}
          transform={transform}
          disabled={!allow}
        >
          <SfBreadcrumbs path="Management/Discount and Special Offers/Edit" />
          <Box style={{ margin: 50 }}>
            <TextInputRA required label="Name" source="name" />
            <TextInputRA label="Description" source="desc" />        
            <TextInputRA required type="password" label="Authorize PIN" source="authorize_pin"  />
            <Box
              style={{
                display: "grid",
                gridGap: 5,
                gridTemplateColumns: "300px auto",
              }}
            >
              <GeneralSelect
                require
                label="Condition"
                source="conditions[0].condition_id"
                resource="conditions"
                isDouble
              />
              <TextInputRA
                required
                isDouble
                label=""
                source="conditions[0].value"
              />
            </Box>
            <Box
              style={{
                display: "grid",
                gridGap: 5,
                gridTemplateColumns: "300px auto",
              }}
            >
              <GeneralSelect
                require
                label="Benefit"
                source="items[0].coupon_id"
                resource="coupons"
                isDouble
              />
              <TextInputRA required isDouble label="" source="items[0].value" />
            </Box>
            <StatusInput />
          </Box>
        </LeftGridEdit>
        <RightGridEdit {...props} noImage />
      </Grid>
      {/* <Edit
        mutationMode="pessimistic"
        onSuccess={onSuccess}
        onFailure={onFailure}
        transform={transform}
        {...props}
      >
        <SimpleForm redirect="list">
          <TextInputRA label="Name" source="name" />
          <TextInputRA label="Description" source="desc" />
          <TextInputRA label="Authorize PIN" source="authorize_pin" />
          <OfferConditionandCouponField />
        </SimpleForm>
      </Edit> */}
    </LayoutContainer>
  );
};

export default OfferEdit;
